<template>
  <div>
    <div class="main-title">雲端打印</div>
    <cloud-print-welcome/>
  </div>
</template>

<script>

import CloudPrintWelcome from "@/components/CloudPrint/Welcome/Main";
export default {
  name: "PageCloudPrintWelcome",
  components: {CloudPrintWelcome},
  props: {
    response: {
      type: Object,
      default: () => {
      },
    },
  },
}
</script>

<style scoped>
.main-title {
  font-size: 18px;
  font-weight: 500;
  text-align: left;
  background: #f8f8f8;
  color: #3b3b3b;
  border-bottom: 1px #f4f4f4 solid;
  text-shadow: none;
  margin:  0 -15px;
  padding: 15px;
}
</style>